export type NavKey = 'home' | 'about' | 'membership' | 'assessments' | 'journal';

export interface NavItem {
  key: NavKey;
  label: string;
  to: string;
  /** Kept out of the nav until there is something to publish. */
  hidden?: boolean;
  /** Hidden when PUBLIC_SITE=hero, where the route redirects to '/'. */
  heroHidden?: boolean;
  /** Listed in the phone menu only; the desktop bar keeps the mockup's two links. */
  mobileOnly?: boolean;
}

/** Mockup nav (brand/GUIDELINES.md §7): ABOUT · MEMBERSHIP · JOURNAL. */
export const NAV_ITEMS: NavItem[] = [
  { key: 'about', label: 'About', to: '/about', heroHidden: true },
  { key: 'membership', label: 'Membership', to: '/membership', heroHidden: true },
  // Owner (2026-09-16): reachable from the phone menu, where the footer is a long scroll away.
  { key: 'assessments', label: 'Assessments', to: '/assessments', heroHidden: true, mobileOnly: true },
  // Journal exists in the mockups; there is no content yet. Flip `hidden` when
  // a /journal route and its first articles land.
  { key: 'journal', label: 'Journal', to: '/journal', hidden: true },
];

/** Members sign in from the site; the mockups do not show it, the owner asked for it. */
export const NAV_LOGIN = { label: 'Log in', to: '/login' } as const;

/**
 * The mockups' "BOOK CONSULTATION". Melio is pre-launch and the only booking
 * flow is behind the site gate, so the owner chose the waitlist with an honest
 * label (2026-09-11). One line to change when booking opens.
 */
export const NAV_CTA = { label: 'Join the waitlist', to: '/waitlist' } as const;
